export const MAX_PROPERTIES_SELECTED = 6
